import React from "react";
import HeaderImage from "./images/image 49.png";
import googleCalendar from "./images/image 28.png";
import office from "./images/image 32.png";
import doxy from "./images/image 33.png";
import clander from "./images/image 36.png";
import FlexibleImage from "./images/image 50.png";
import docprimary from "./images/docprimary.png";

function App() {
  return (
    <div className="min-h-screen font-dm-sans">
      <header className="bg-white">
        <nav className="container flex items-center justify-center px-6 py-8 mx-auto space-x-4">
          <div className="flex items-center space-x-2">
            <span className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-md bg-primary">
              <svg className="h-6" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.54607 4.14488C7.5418 4.14488 8.53966 5.31099 8.53966 7.64321V11.9247C8.53966 12.2496 8.44104 12.5049 8.24378 12.6905C8.05813 12.8762 7.79706 12.969 7.46058 12.969C7.12409 12.969 6.85722 12.8762 6.65997 12.6905C6.46271 12.5049 6.36409 12.2496 6.36409 11.9247V7.64321C6.36409 7.02824 6.23645 6.58153 5.98119 6.30305C5.73752 6.01298 5.34882 5.86794 4.81508 5.86794C4.18851 5.86794 3.68378 6.06519 3.30088 6.45969C2.92958 6.8542 2.74393 7.38214 2.74393 8.04351V11.9247C2.74393 12.2496 2.64531 12.5049 2.44806 12.6905C2.2508 12.8762 1.98393 12.969 1.64744 12.969C1.31096 12.969 1.04408 12.8762 0.846833 12.6905C0.661184 12.5049 0.568359 12.2496 0.568359 11.9247V1.51679C0.568359 1.21511 0.666985 0.971447 0.864237 0.785798C1.07309 0.600149 1.33996 0.507324 1.66485 0.507324C1.98973 0.507324 2.2508 0.594347 2.44806 0.768393C2.64531 0.942439 2.74393 1.1803 2.74393 1.48198V5.53725C3.03401 5.08473 3.41691 4.74244 3.89264 4.51038C4.37996 4.26672 4.93111 4.14488 5.54607 4.14488Z" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M14.6965 0.557296C15.1495 0.718018 15.3864 1.21549 15.2257 1.66844L11.3966 12.4593C11.2359 12.9122 10.7385 13.1491 10.2855 12.9884C9.83256 12.8277 9.59567 12.3302 9.75639 11.8773L13.5854 1.08641C13.7461 0.633467 14.2436 0.396574 14.6965 0.557296Z" fill="white" />
              </svg>
            </span>

            <span className="text-lg font-bold text-gray-800">
              Open Scheduling
            </span>
          </div>
        </nav>

        <div className="container px-6 mx-auto text-center pt-28 sm:pt-36">
          <h2 className="text-3xl font-bold text-gray-800 sm:text-5xl">Be Efficient with <span className=" text-primary">Effective Scheduling</span></h2>
          <p className="mt-3 text-base text-gray-600 sm:mt-6 sm:text-xl">Integrate with your existing calendars to serve your customers</p>

          <div className="flex flex-col mt-8 space-y-3 sm:space-x-4 sm:space-y-0 sm:flex-row sm:justify-center">
            <input placeholder="Enter Your Email" type="text" className="px-6 py-3 text-gray-700 bg-gray-100 border border-transparent rounded-md sm:w-80 focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40" />

            <button className="px-8 py-2 text-center text-white capitalize transition-colors duration-200 transform rounded-md bg-primary hover:bg-opacity-80">
              Join Waitlist
            </button>
          </div>

          <img className="mt-12 lg:mt-24" src={HeaderImage} alt="" />

          <div className="max-w-md mx-auto mt-10 mb-16">
            <h4 className="text-lg tracking-widest text-gray-500 uppercase">INTEGRATIONS WITH</h4>

            <div className="grid grid-cols-4 gap-4 mt-6 place-items-center">
              <a href="#">
                <img className="h-8" src={office} alt="" />
              </a>

              <a href="#">
                <img className="h-8" src={googleCalendar} alt="" />
              </a>

              <a href="#">
                <img className="h-8" src={clander} alt="" />
              </a>

              <a href="#">
                <img className="h-8" src={doxy} alt="" />
              </a>
            </div>
          </div>
        </div>
      </header>

      <section className="relative bg-primary">
        <div className="container px-6 py-16 mx-auto lg:flex lg:space-x-12">
          <div className="lg:w-1/2">
            <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M37.9167 5.83337L8.75 40.8334H35L32.0833 64.1667L61.25 29.1667H35L37.9167 5.83337Z" stroke="#ACA9F1" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <h2 className="max-w-lg mt-6 text-4xl font-bold text-white">Build for Developers & Independent Service Providers</h2>

            <p className="max-w-lg mt-4 text-lg text-gray-300">No need to code your own components or writing the logic. Just simply use the codebase or interact with our API to quickly get up and running.</p>

            <a href="#" className="inline-block px-8 py-3 mt-8 font-medium tracking-widest text-center uppercase transition-colors duration-200 transform bg-white rounded-md text-primary hover:bg-opacity-80">
              Documentation
            </a>
          </div>

          <div className="mt-10 space-y-10 lg:mt-0 lg:w-1/2">
            <div className="max-w-sm">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.1" width="60" height="60" fill="#ACA9F1" />
                <path d="M23.3328 38.3334V35.1084C23.3641 34.711 23.3104 34.3115 23.1753 33.9365C23.0403 33.5615 22.8269 33.2195 22.5495 32.9334C25.1661 32.6417 27.9161 31.65 27.9161 27.1C27.9159 25.9366 27.4684 24.8177 26.6661 23.975C27.046 22.9571 27.0192 21.832 26.5911 20.8334C26.5911 20.8334 25.6078 20.5417 23.3328 22.0667C21.4228 21.549 19.4095 21.549 17.4995 22.0667C15.2245 20.5417 14.2411 20.8334 14.2411 20.8334C13.8131 21.832 13.7863 22.9571 14.1661 23.975C13.3579 24.8239 12.9099 25.9529 12.9161 27.125C12.9161 31.6417 15.6661 32.6334 18.2828 32.9584C18.0086 33.2417 17.7972 33.5795 17.6622 33.95C17.5273 34.3204 17.4718 34.7151 17.4995 35.1084V38.3334M17.4995 35.8334C13.3328 37.0834 13.3328 33.75 11.6661 33.3334L17.4995 35.8334Z" stroke="#ACA9F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M40.0002 20.8334V39.1667" stroke="#ACA9F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M44.1662 24.1666H37.9162C37.1426 24.1666 36.4008 24.4739 35.8538 25.0209C35.3068 25.5679 34.9995 26.3097 34.9995 27.0833C34.9995 27.8568 35.3068 28.5987 35.8538 29.1457C36.4008 29.6927 37.1426 30 37.9162 30H42.0828C42.8564 30 43.5983 30.3073 44.1452 30.8542C44.6922 31.4012 44.9995 32.1431 44.9995 32.9166C44.9995 33.6902 44.6922 34.432 44.1452 34.979C43.5983 35.526 42.8564 35.8333 42.0828 35.8333H34.9995" stroke="#ACA9F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

              <h4 className="mt-6 text-xl font-medium text-white">Shared Source</h4>
              <p className="mt-4 text-gray-300">Our Shared Source approach towards development contributes to our code’s reliability and security of our solutions</p>
            </div>

            <div className="max-w-sm">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.1" width="60" height="60" fill="#ACA9F1" />
                <path d="M43.8165 16.1835C43.674 16.0409 43.4743 15.9553 43.3033 15.9553H17.6962C17.297 15.9553 16.9548 16.2975 16.9548 16.6967V42.3038C16.9548 42.7029 17.2971 43.0451 17.6962 43.0451H30.4997C30.6994 43.0451 30.8989 42.9595 31.0129 42.817C31.1555 42.6744 31.2411 42.4747 31.2411 42.3038L31.2413 38.1119H31.2983C31.783 38.4826 32.3534 38.6536 32.9522 38.6536C34.4921 38.6536 35.7183 37.399 35.7183 35.8876C35.7183 34.3477 34.4637 33.0931 32.9522 33.0931C32.3534 33.0931 31.7545 33.2928 31.2983 33.6348L31.2413 30.2131H35.3475C35.5185 30.2131 35.7182 30.1561 35.8892 30.0421C36.0889 29.8711 36.1743 29.6142 36.1458 29.3863V28.3883C36.1458 28.1886 36.0602 28.0177 35.9461 27.8751C35.718 27.647 35.6039 27.3334 35.6039 26.9912C35.6039 26.2783 36.1743 25.708 36.9156 25.708C37.6285 25.708 38.1989 26.2783 38.1989 26.9912C38.1989 27.3334 38.0848 27.6185 37.8566 27.8751C37.7141 28.0177 37.6569 28.1889 37.6569 28.3883V29.4434C37.6569 29.586 37.6854 29.7285 37.771 29.8713C37.9136 30.1279 38.1989 30.2704 38.4839 30.242H43.303C43.7022 30.242 44.0444 29.8997 44.0444 29.5006V16.6971C44.0446 16.4969 43.959 16.3259 43.8165 16.1834L43.8165 16.1835ZM29.7581 17.4381V20.8598H29.7012C29.2164 20.4891 28.6461 20.3181 28.0472 20.3181C26.5074 20.3181 25.2812 21.5727 25.2812 23.0842C25.2812 24.624 26.5358 25.8786 28.0472 25.8786C28.6461 25.8786 29.2449 25.6789 29.7012 25.3369L29.7581 28.7587H25.595C25.4524 28.7587 25.2812 28.8156 25.1671 28.9012C24.9674 29.0438 24.8534 29.2719 24.8534 29.5001V30.5836C24.8534 30.7833 24.939 30.9543 25.0531 31.0969C25.2812 31.325 25.3953 31.6385 25.3953 31.9808C25.3953 32.6937 24.8249 33.264 24.0836 33.264C23.3706 33.264 22.8003 32.6937 22.8003 31.9808C22.8003 31.6386 22.9144 31.3535 23.1425 31.0969C23.2851 30.9543 23.3422 30.7831 23.3422 30.5836V29.5001C23.3422 29.3291 23.2853 29.1578 23.1712 29.0438C23.0287 28.8728 22.829 28.7587 22.6009 28.7587H18.4375V17.4382L29.7581 17.4381ZM31.5831 35.1459C31.7828 35.1459 31.9538 35.0603 32.0963 34.9462C32.3245 34.7181 32.638 34.604 32.9802 34.604C33.6931 34.604 34.2635 35.1744 34.2635 35.9157C34.2635 36.6287 33.6931 37.199 32.9802 37.199C32.638 37.199 32.3529 37.0849 32.0963 36.8568C31.9538 36.7142 31.7826 36.6571 31.5831 36.6571L30.4995 36.6573C30.1858 36.6573 29.9007 36.857 29.7866 37.1705C29.7581 37.2561 29.7581 37.3702 29.7581 37.4556V41.5618H18.4376V30.2412H21.8594V30.2982C21.4887 30.7829 21.3177 31.3533 21.3177 31.9521C21.3177 33.492 22.5723 34.7182 24.0837 34.7182C25.6236 34.7182 26.8782 33.4636 26.8782 31.9521C26.8782 31.3533 26.6785 30.7545 26.3365 30.2982L29.7582 30.2412V34.319C29.7298 34.4331 29.7582 34.5472 29.7867 34.6612C29.9008 34.9463 30.1859 35.146 30.4711 35.146L31.5831 35.1459ZM42.5616 28.7586H39.1399V28.7017C39.5106 28.2169 39.6816 27.6466 39.6816 27.0477C39.6816 25.5078 38.427 24.2817 36.9155 24.2817C35.3756 24.2817 34.1211 25.5362 34.1211 27.0477C34.1211 27.6465 34.3207 28.2454 34.6627 28.7017L31.241 28.7586L31.2412 24.5668C31.2412 24.2817 31.0702 24.0251 30.8421 23.911C30.728 23.8541 30.5855 23.8254 30.4714 23.8254H29.4447C29.245 23.8254 29.074 23.911 28.9315 24.0251C28.7033 24.2532 28.3898 24.3673 28.0476 24.3673C27.3347 24.3673 26.7643 23.7969 26.7643 23.0556C26.7643 22.3427 27.3347 21.7723 28.0476 21.7723C28.3898 21.7723 28.6749 21.8864 28.9315 22.1146C29.074 22.2571 29.2453 22.3142 29.4447 22.3142H30.4427C30.5852 22.3427 30.7277 22.3142 30.8705 22.2286C31.1271 22.1146 31.2697 21.8579 31.2697 21.5729V17.4379H42.5619L42.5616 28.7586Z" fill="#ACA9F1" />
              </svg>


              <h4 className="mt-6 text-xl font-medium text-white">Easy to Customize</h4>
              <p className="mt-4 text-gray-300">Each module is put together to fulfill your requirements while being developer-friendly and easy to modify</p>
            </div>

            <div className="max-w-sm">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.1" width="60" height="60" fill="#ACA9F1" />
                <path d="M32 20H24C23.4696 20 22.9609 20.2107 22.5858 20.5858C22.2107 20.9609 22 21.4696 22 22V38C22 38.5304 22.2107 39.0391 22.5858 39.4142C22.9609 39.7893 23.4696 40 24 40H36C36.5304 40 37.0391 39.7893 37.4142 39.4142C37.7893 39.0391 38 38.5304 38 38V26L32 20Z" stroke="#ACA9F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M32 20V26H38" stroke="#ACA9F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M34 31H26" stroke="#ACA9F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M34 35H26" stroke="#ACA9F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M28 27H27H26" stroke="#ACA9F1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

              <h4 className="mt-6 text-xl font-medium text-white">Extensive Documentation</h4>
              <p className="mt-4 text-gray-300">Build an interface on back of the API that we provide.</p>
            </div>

            <div className="max-w-sm">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.1" width="60" height="60" fill="#ACA9F1" />
                <path d="M15.2929 37.2929C14.9024 37.6834 14.9024 38.3166 15.2929 38.7071C15.6834 39.0976 16.3166 39.0976 16.7071 38.7071L15.2929 37.2929ZM26 28L26.7071 27.2929C26.3166 26.9024 25.6834 26.9024 25.2929 27.2929L26 28ZM32 34L31.2929 34.7071C31.6834 35.0976 32.3166 35.0976 32.7071 34.7071L32 34ZM45 22C45 21.4477 44.5523 21 44 21H35C34.4477 21 34 21.4477 34 22C34 22.5523 34.4477 23 35 23H43V31C43 31.5523 43.4477 32 44 32C44.5523 32 45 31.5523 45 31V22ZM16.7071 38.7071L26.7071 28.7071L25.2929 27.2929L15.2929 37.2929L16.7071 38.7071ZM25.2929 28.7071L31.2929 34.7071L32.7071 33.2929L26.7071 27.2929L25.2929 28.7071ZM32.7071 34.7071L44.7071 22.7071L43.2929 21.2929L31.2929 33.2929L32.7071 34.7071Z" fill="#ACA9F1" />
              </svg>

              <h4 className="mt-6 text-xl font-medium text-white">Faster Time to Market</h4>
              <p className="mt-4 text-gray-300">Each module is put together to fulfill your requirements while being developer-friendly and easy to modify</p>
            </div>
          </div>
        </div>

        <svg className="absolute inset-y-0 right-0 w-full" viewBox="0 0 1280 670" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_147_10965" maskUnits="userSpaceOnUse" x="0" y="0" width="1280" height="670">
            <rect width="1280" height="670" fill="#546CCC" />
          </mask>
          <g mask="url(#mask0_147_10965)">
            <path opacity="0.05" d="M1276.67 43.6686L1080 352.484H1257L1237.33 558.361L1434 249.546H1257L1276.67 43.6686Z" stroke="white" strokeWidth="20.2286" strokeLinecap="round" strokeLinejoin="round" />
            <circle opacity="0.1" cx="1086" cy="55" r="314.5" stroke="white" />
            <circle opacity="0.1" cx="788" cy="644" r="481.5" stroke="white" />
            <circle opacity="0.1" cx="72.5" cy="400.5" r="534" stroke="white" />
            <circle opacity="0.1" cx="606.5" cy="-17.5" r="534" stroke="white" />
          </g>
        </svg>
      </section>

      <section className="container px-6 py-16 mx-auto ">
        <h2 className="relative max-w-lg mx-auto text-2xl font-bold text-center text-gray-800 md:text-4xl">
          <span className="relative z-20 text-primary">Flexible Scheduling</span> for Personal & Business Needs
          <div className="bg-[#ACA9F1] hidden lg:flex h-16 w-16 justify-center items-center absolute top-10  right-[6.4rem] z-10 bg-opacity-10">
            <svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.292893 16.2929C-0.0976311 16.6834 -0.0976311 17.3166 0.292893 17.7071C0.683417 18.0976 1.31658 18.0976 1.70711 17.7071L0.292893 16.2929ZM11 7L11.7071 6.29289C11.3166 5.90237 10.6834 5.90237 10.2929 6.29289L11 7ZM17 13L16.2929 13.7071C16.6834 14.0976 17.3166 14.0976 17.7071 13.7071L17 13ZM30 1C30 0.447715 29.5523 0 29 0H20C19.4477 0 19 0.447715 19 1C19 1.55228 19.4477 2 20 2H28V10C28 10.5523 28.4477 11 29 11C29.5523 11 30 10.5523 30 10V1ZM1.70711 17.7071L11.7071 7.70711L10.2929 6.29289L0.292893 16.2929L1.70711 17.7071ZM10.2929 7.70711L16.2929 13.7071L17.7071 12.2929L11.7071 6.29289L10.2929 7.70711ZM17.7071 13.7071L29.7071 1.70711L28.2929 0.292893L16.2929 12.2929L17.7071 13.7071Z" fill="#ACA9F1" />
            </svg>
          </div>
        </h2>

        <div className="mt-8 lg:mt-16 lg:flex lg:items-center lg:space-x-12">
          <div className="w-full space-y-12 lg:w-2/5">
            <button className="flex items-center w-full pl-6 space-x-8 border-l-4 border-transparent ">
              <div>
                <svg width="36" height="36" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_444_5068)">
                    <path d="M3.28115 29.0625H22.0312H24.8437H27.6562C27.9154 29.0625 28.1249 28.8525 28.1249 28.5938V1.40625C28.1249 1.1475 27.9154 0.9375 27.6562 0.9375H24.8437H22.0312H3.28115C3.02194 0.9375 2.8124 1.1475 2.8124 1.40625V17.1497L1.5435 18.4186C0.843655 19.1184 0.843655 20.2566 1.5435 20.9564C1.89319 21.3066 2.35303 21.4814 2.8124 21.4814V28.5938C2.8124 28.8525 3.02194 29.0625 3.28115 29.0625ZM27.1874 28.125H25.3124V1.875H27.1874V28.125ZM24.3749 28.125H22.4999V1.875H24.3749V28.125ZM2.20631 20.2936C1.87209 19.9594 1.87209 19.4156 2.20631 19.0814L3.61256 17.6752L5.62491 15.6628L5.76225 15.8002L6.69975 16.7377L6.83709 16.875L3.4185 20.2936C3.33412 20.3775 3.23287 20.4427 3.11569 20.4867C3.11475 20.4872 3.11428 20.4877 3.11334 20.4881C2.80819 20.602 2.451 20.5383 2.20631 20.2936ZM15.9374 6.5625C15.9374 6.04547 16.3579 5.625 16.8749 5.625C17.3919 5.625 17.8124 6.04547 17.8124 6.5625C17.8124 7.07953 17.3919 7.5 16.8749 7.5C16.3579 7.5 15.9374 7.07953 15.9374 6.5625ZM16.8749 8.4375C17.909 8.4375 18.7499 9.27844 18.7499 10.3125V10.7812H14.9999V10.3125C14.9999 9.27844 15.8408 8.4375 16.8749 8.4375ZM18.231 7.85016C18.5507 7.51359 18.7499 7.06172 18.7499 6.5625C18.7499 5.52844 17.909 4.6875 16.8749 4.6875C15.8408 4.6875 14.9999 5.52844 14.9999 6.5625C14.9999 7.06172 15.1991 7.51359 15.5188 7.85016C14.6652 8.32219 14.0835 9.22453 14.0652 10.2623C14.0643 10.2605 14.0638 10.2581 14.0629 10.2562V3.75H19.6879V10.3125C19.6874 9.25313 19.0987 8.32969 18.231 7.85016ZM13.1877 10.6097C13.2496 10.7227 13.3058 10.8413 13.3551 10.965C13.3565 10.9683 13.3574 10.972 13.3588 10.9753C13.4076 11.1 13.4497 11.2294 13.4849 11.363C13.5533 11.6273 13.5937 11.9025 13.5937 12.1875C13.5937 13.9969 12.1213 15.4688 10.3124 15.4688C9.60975 15.4688 8.96006 15.2447 8.42522 14.8673C8.11725 14.6503 7.85147 14.3845 7.63397 14.0766C7.25569 13.5417 7.03116 12.8911 7.03116 12.1875C7.03116 10.3781 8.5035 8.90625 10.3124 8.90625C11.5499 8.90625 12.629 9.59531 13.1877 10.6097ZM7.19709 15.0291C7.21912 15.0534 7.24397 15.075 7.26647 15.0984C7.30959 15.1439 7.35365 15.188 7.39912 15.2316C7.4235 15.255 7.446 15.2808 7.47131 15.3037L7.03116 15.7434L6.75647 15.4688L7.19709 15.0291ZM4.08131 20.9564L7.83131 17.2064C8.01459 17.0231 8.01459 16.7269 7.83131 16.5436L7.69397 16.4062L8.24147 15.8588C8.85412 16.2056 9.55959 16.4062 10.3124 16.4062C12.6388 16.4062 14.5312 14.5134 14.5312 12.1875C14.5312 12.0291 14.5208 11.873 14.5035 11.7188H14.5312H19.2187H20.1562C20.4154 11.7188 20.6249 11.5087 20.6249 11.25V3.28125C20.6249 3.0225 20.4154 2.8125 20.1562 2.8125H13.5937C13.3344 2.8125 13.1249 3.0225 13.1249 3.28125V9.05203C12.3777 8.38078 11.3933 7.96875 10.3124 7.96875C7.986 7.96875 6.09366 9.86156 6.09366 12.1875C6.09366 12.9403 6.29428 13.6462 6.64116 14.2584L6.09366 14.8059L5.95631 14.6686C5.77303 14.4853 5.47678 14.4853 5.2935 14.6686L3.7499 16.2122V1.875H21.5624V28.125H3.7499V21.2166C3.75553 21.2133 3.75975 21.2081 3.76537 21.2044C3.87694 21.1341 3.98428 21.0539 4.08131 20.9564Z" fill="black" fill-opacity="0.5" />
                    <path d="M7.5 12.1875H8.4375C8.4375 11.1534 9.27844 10.3125 10.3125 10.3125V9.375C8.76141 9.375 7.5 10.6364 7.5 12.1875Z" fill="black" fill-opacity="0.5" />
                    <path d="M11.7188 3.28125H4.6875V4.21875H11.7188V3.28125Z" fill="black" fill-opacity="0.5" />
                    <path d="M8.90625 5.15625H4.6875V6.09375H8.90625V5.15625Z" fill="black" fill-opacity="0.5" />
                    <path d="M11.7188 5.15625H9.84375V6.09375H11.7188V5.15625Z" fill="black" fill-opacity="0.5" />
                    <path d="M20.625 17.3438H8.90625V18.2812H20.625V17.3438Z" fill="black" fill-opacity="0.5" />
                    <path d="M10.7812 19.2188H6.5625V20.1562H10.7812V19.2188Z" fill="black" fill-opacity="0.5" />
                    <path d="M20.625 19.2188H11.7188V20.1562H20.625V19.2188Z" fill="black" fill-opacity="0.5" />
                    <path d="M20.625 21.0938H4.6875V22.0312H20.625V21.0938Z" fill="black" fill-opacity="0.5" />
                    <path d="M8.90625 22.9688H4.6875V23.9062H8.90625V22.9688Z" fill="black" fill-opacity="0.5" />
                    <path d="M20.625 22.9688H9.84375V23.9062H20.625V22.9688Z" fill="black" fill-opacity="0.5" />
                  </g>
                  <defs>
                    <clipPath id="clip0_444_5068">
                      <rect width="36" height="36" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <div className="text-left">
                <h2 className="text-2xl font-medium text-gray-800">Interview</h2>
                <p className="mt-1 text-gray-600">Hiring Managers can schedule Interviews </p>
              </div>
            </button>

            <button className="flex items-center w-full pl-6 space-x-8 border-l-4 border-primary ">
              <div className="flex-shrink-0 ">
                <img className="h-9" src={docprimary} alt="" />
              </div>

              <div className="text-left">
                <h2 className="text-2xl font-medium text-primary">Health Care</h2>
                <p className="mt-1 text-gray-600">Doctors & Patient can schedule meeting  </p>
              </div>
            </button>

            <button className="flex items-center w-full pl-6 space-x-8 border-l-4 border-transparent ">
              <div>
                <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" stroke="black" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2V2Z" stroke="black" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>

              <div className="text-left">
                <h2 className="text-2xl font-medium text-gray-800">Education</h2>
                <p className="mt-1 text-gray-600">Teachers can schedule lectures </p>
              </div>
            </button>
          </div>

          <div className="w-full mt-8 lg:w-3/5 lg:mt-0 ">
            <img className="w-full" src={FlexibleImage} alt="" />
          </div>
        </div>
      </section>

      <section className="container px-6 py-16 mx-auto ">
        <h2 className="relative max-w-lg mx-auto text-2xl font-bold text-center text-gray-800 md:text-4xl">
          Why to use <span className="relative z-20 capitalize text-primary">block approach</span> of hlth/dev?
        </h2>

        <p className="max-w-5xl mx-auto mt-6 text-center text-gray-500">Software is increasingly become complex and requires more time to develop and integrate. Traditionally the decision is between Build vs Buy, instead with hlth/dev we can enable the median between Build and Buy - Buy to Build. In this approach companies buy blocks or scaffolds to then customize it specific to their application. </p>

        <div className="flex items-center justify-center mt-8">
          <svg width="68" height="82" viewBox="0 0 68 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.3" d="M32 34L31.5004 33.98L32 34ZM3 43L2.54547 43.2083L3 43ZM43 23L42.899 23.4897L43 23ZM63.0917 81.7886C63.2511 82.0141 63.5631 82.0677 63.7886 81.9083L67.4636 79.3113C67.6891 79.152 67.7427 78.84 67.5834 78.6144C67.424 78.3889 67.112 78.3353 66.8865 78.4947L63.6198 80.8031L61.3114 77.5364C61.152 77.3109 60.84 77.2573 60.6145 77.4167C60.389 77.576 60.3353 77.888 60.4947 78.1136L63.0917 81.7886ZM0.38049 1.48551C5.7418 2.80522 13.7447 6.02729 20.2959 11.387C26.8407 16.7415 31.8921 24.1875 31.5004 33.98L32.4996 34.02C32.9079 23.8125 27.6259 16.0919 20.9291 10.613C14.2386 5.13938 6.09153 1.86145 0.61951 0.514493L0.38049 1.48551ZM31.5004 33.98C31.2533 40.1584 29.6801 44.4835 27.4282 47.3304C25.1819 50.1702 22.2314 51.5771 19.1392 51.8773C12.9147 52.4817 6.11609 48.5987 3.45453 42.7917L2.54547 43.2083C5.38391 49.4013 12.5853 53.5183 19.2358 52.8727C22.5811 52.5479 25.7868 51.0173 28.2125 47.9508C30.6324 44.8915 32.2467 40.3416 32.4996 34.02L31.5004 33.98ZM3.45453 42.7917C1.70942 38.9842 2.21398 35.7198 4.18127 32.9721C6.17387 30.189 9.69616 27.9005 14.0402 26.1887C22.7248 22.7666 34.4453 21.7464 42.899 23.4897L43.101 22.5103C34.4498 20.7263 22.5319 21.7678 13.6736 25.2584C9.2461 27.003 5.52075 29.3835 3.36819 32.39C1.19032 35.4318 0.652187 39.0775 2.54547 43.2083L3.45453 42.7917ZM42.899 23.4897C48.728 24.6917 53.1519 27.3083 56.4542 30.9396C59.7613 34.5763 61.9643 39.2544 63.3059 44.605C65.9919 55.3177 65.2033 68.6384 63.0073 81.4153L63.9928 81.5847C66.1968 68.7616 67.0126 55.2769 64.2759 44.3618C62.906 38.8986 60.6408 34.0572 57.194 30.2668C53.7423 26.4711 49.1265 23.7528 43.101 22.5103L42.899 23.4897Z" fill="black" />
          </svg>
        </div>

        <div className="mt-8 lg:mt-16">
          <div className="flex flex-col">
            <div className="-my-2 overflow-x-auto xl:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <div className="overflow-hidden">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead>
                      <tr>
                        <th scope="col" className="px-6 py-4 pr-16 text-lg font-medium text-left text-gray-500 whitespace-nowrap">
                          Type Of Solution
                        </th>

                        <th scope="col" className="px-6 py-4 pr-16 text-lg font-medium text-left text-gray-800 whitespace-nowrap">
                          Turnkey Solution <br /> (Off-The-Self Solution)
                        </th>

                        <th scope="col" className="px-6 py-4 pr-16 text-lg font-medium text-left text-primary whitespace-nowrap">
                          Buy Scaffold and <br /> customize rest
                        </th>

                        <th scope="col" className="px-6 py-4 pr-16 text-lg font-medium text-left text-gray-800 whitespace-nowrap">
                          Develop from Scratch
                        </th>
                      </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-200">
                      <tr>
                        <td className="px-6 py-8 text-gray-500 whitespace-nowrap">
                          Time To Market
                        </td>

                        <td className="px-6 py-8 text-gray-800 whitespace-nowrap">
                          Shortest
                        </td>

                        <td className="px-6 py-8 text-primary whitespace-nowrap">
                          Medium <br /> <span className="text-gray-400">(appx Save time of 6 to 10 sprints)</span>
                        </td>

                        <td className="px-6 py-8 text-gray-800 whitespace-nowrap">
                          Longest
                        </td>
                      </tr>

                      <tr>
                        <td className="px-6 py-8 text-gray-500 whitespace-nowrap">
                          Cost
                        </td>

                        <td className="px-6 py-8 text-gray-800 whitespace-nowrap">
                          Medium - High
                        </td>

                        <td className="px-6 py-8 text-primary whitespace-nowrap">
                          Medium
                        </td>

                        <td className="px-6 py-8 text-gray-800 whitespace-nowrap">
                          High
                        </td>
                      </tr>

                      <tr>
                        <td className="px-6 py-8 text-gray-500 whitespace-nowrap">
                          Customization
                        </td>

                        <td className="px-6 py-8 text-gray-800 whitespace-nowrap">
                          Limited
                        </td>

                        <td className="px-6 py-8 text-primary whitespace-nowrap">
                          Full
                        </td>

                        <td className="px-6 py-8 text-gray-800 whitespace-nowrap">
                          Full
                        </td>
                      </tr>

                      <tr>
                        <td className="px-6 py-8 text-gray-500 whitespace-nowrap">
                          Extensible
                        </td>

                        <td className="px-6 py-8 text-gray-800 whitespace-nowrap">
                          Limited
                        </td>

                        <td className="px-6 py-8 text-primary whitespace-nowrap">
                          Full
                        </td>

                        <td className="px-6 py-8 text-gray-800 whitespace-nowrap">
                          Full
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container px-6 py-16 mx-auto lg:flex lg:space-x-12">
        <div className="lg:w-1/2">
          <h2 className="max-w-lg mt-6 text-4xl font-bold text-gray-800">We Got Everything Covered</h2>

          <p className="max-w-lg mt-4 text-lg text-gray-500">No need to code your own components or writing the logic. Just simply use the codebase or interact with our API to quickly get up and running.</p>

          <a href="#" className="inline-block px-8 py-3 mt-8 font-medium tracking-widest text-center text-white uppercase transition-colors duration-200 transform rounded-md bg-primary hover:bg-opacity-80">
            Lear More
          </a>
        </div>

        <div className="grid grid-cols-1 gap-8 mt-10 lg:mt-0 lg:w-1/2 md:grid-cols-2">
          <div>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.4674 30.5834L17.6342 34.5834C18.3008 35.25 19.8008 35.5834 20.8008 35.5834H27.1342C29.1342 35.5834 31.3008 34.0834 31.8008 32.0834L35.8008 19.9167C36.6342 17.5834 35.1342 15.5833 32.6342 15.5833H25.9675C24.9675 15.5833 24.1342 14.75 24.3008 13.5833L25.1342 8.24997C25.4675 6.74997 24.4675 5.0833 22.9675 4.5833C21.6342 4.0833 19.9675 4.74997 19.3008 5.74997L12.4674 15.9166" stroke="#58C4C3" strokeWidth="2.5" strokeMiterlimit="10" />
              <path d="M3.9681 30.5832V14.2499C3.9681 11.9165 4.9681 11.0832 7.30143 11.0832H8.9681C11.3014 11.0832 12.3014 11.9165 12.3014 14.2499V30.5832C12.3014 32.9165 11.3014 33.7499 8.9681 33.7499H7.30143C4.9681 33.7499 3.9681 32.9165 3.9681 30.5832Z" stroke="#546CCC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <h2 className="mt-4 text-xl font-medium text-gray-800">Multi Profile</h2>

            <p className="mt-4 text-gray-500">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
          </div>

          <div>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24.8333 3.33331H15.1667C14.0334 3.33331 12.4333 3.99998 11.6333 4.79998L4.80001 11.6333C4.00001 12.4333 3.33334 14.0333 3.33334 15.1667V24.8333C3.33334 25.9666 4.00001 27.5666 4.80001 28.3666L11.6333 35.2C12.4333 36 14.0334 36.6666 15.1667 36.6666H24.8333C25.9667 36.6666 27.5667 36 28.3667 35.2L35.2 28.3666C36 27.5666 36.6667 25.9666 36.6667 24.8333V15.1667C36.6667 14.0333 36 12.4333 35.2 11.6333L28.3667 4.79998C27.5667 3.99998 25.9667 3.33331 24.8333 3.33331Z" stroke="#546CCC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M14.1667 25.8333L25.8333 14.1666" stroke="#58C4C3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M25.8333 25.8333L14.1667 14.1666" stroke="#58C4C3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>


            <h2 className="mt-4 text-xl font-medium text-gray-800">100% GDPR & COPR Compliant</h2>

            <p className="mt-4 text-gray-500">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
          </div>

          <div>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.45 20C4.13333 18.4167 3.33333 16.3833 3.33333 14.1667C3.33333 9.13333 7.45 5 12.5 5H20.8333C25.8667 5 30 9.13333 30 14.1667C30 19.2 25.8833 23.3333 20.8333 23.3333H16.6667" stroke="#546CCC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M34.55 20C35.8667 21.5833 36.6667 23.6166 36.6667 25.8333C36.6667 30.8666 32.55 35 27.5 35H19.1667C14.1333 35 10 30.8666 10 25.8333C10 20.8 14.1167 16.6666 19.1667 16.6666H23.3333" stroke="#58C4C3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>


            <h2 className="mt-4 text-xl font-medium text-gray-800">100% GDPR & COPR Compliant</h2>

            <p className="mt-4 text-gray-500">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
          </div>

          <div>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.2676 6.66663V28.3333" stroke="#58C4C3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M26.2175 11.0336V33.3335" stroke="#58C4C3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M3.81509 12.9666V29.1833C3.81509 32.35 6.06509 33.65 8.79843 32.0833L12.7151 29.85C13.5651 29.3666 14.9818 29.3166 15.8651 29.7666L24.6152 34.15C25.4985 34.5833 26.9152 34.55 27.7652 34.0666L34.9818 29.9333C35.8985 29.4 36.6652 28.1 36.6652 27.0333V10.8166C36.6652 7.64992 34.4152 6.34992 31.6818 7.91659L27.7652 10.1499C26.9152 10.6333 25.4985 10.6833 24.6152 10.2333L15.8651 5.86659C14.9818 5.43325 13.5651 5.46659 12.7151 5.94992L5.49843 10.0833C4.56509 10.6166 3.81509 11.9166 3.81509 12.9666Z" stroke="#546CCC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>



            <h2 className="mt-4 text-xl font-medium text-gray-800">100% GDPR & COPR Compliant</h2>

            <p className="mt-4 text-gray-500">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
          </div>

          <div>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30.5333 20.0003C34.8667 20.0003 36.6667 18.3336 35.0667 12.8669C33.9833 9.18359 30.8167 6.01693 27.1333 4.93359C21.6667 3.33359 20 5.13359 20 9.46693V14.2669C20 18.3336 21.6667 20.0003 25 20.0003H30.5333Z" stroke="#58C4C3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M33.334 24.4997C31.784 32.2164 24.384 37.8164 15.9674 36.4497C9.6507 35.433 4.56737 30.3497 3.53403 24.033C2.18403 15.6497 7.7507 8.24965 15.434 6.68298" stroke="#546CCC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>


            <h2 className="mt-4 text-xl font-medium text-gray-800">100% GDPR & COPR Compliant</h2>

            <p className="mt-4 text-gray-500">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
          </div>

          <div>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30.5333 20.0003C34.8667 20.0003 36.6667 18.3336 35.0667 12.8669C33.9833 9.18359 30.8167 6.01693 27.1333 4.93359C21.6667 3.33359 20 5.13359 20 9.46693V14.2669C20 18.3336 21.6667 20.0003 25 20.0003H30.5333Z" stroke="#58C4C3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M33.334 24.4997C31.784 32.2164 24.384 37.8164 15.9674 36.4497C9.6507 35.433 4.56737 30.3497 3.53403 24.033C2.18403 15.6497 7.7507 8.24965 15.434 6.68298" stroke="#546CCC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <h2 className="mt-4 text-xl font-medium text-gray-800">100% GDPR & COPR Compliant</h2>

            <p className="mt-4 text-gray-500">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
          </div>
        </div>
      </section>

      <section className="container px-6 py-16 mx-auto">
        <h3 className="text-2xl font-semibold text-gray-800">
          Frequently Asked Question
        </h3>
        <p className="mt-4 text-lg text-gray-600">
          Answering the questions related to the product.{" "}
        </p>

        <div className="mt-10 space-y-8">
          <div>
            <button
              type="button"
              className="flex space-x-2 text-gray-700 transition-colors duration-200 transform focus:outline-none hover:text-gray-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>

              <h3 className="text-lg text-left">
                How can I integrate this with my existing node application
              </h3>
            </button>
          </div>

          <div className="p-6 -m-6 rounded-md bg-gray-50">
            <button
              type="button"
              className="flex space-x-2 text-gray-700 transition-colors duration-200 transform focus:outline-none hover:text-gray-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>

              <h3 className="text-lg text-left">
                How can I integrate this with my existing node application
              </h3>
            </button>

            <p className="pl-8 mt-3 text-gray-600">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Consectetur veniam officia deserunt eligendi nisi cum, repudiandae
              deleniti adipisci, unde consequatur saepe! Unde perspiciatis
              nostrum sed vero aliquam. Nobis, nam nostrum.
            </p>
          </div>

          <div>
            <button
              type="button"
              className="flex space-x-2 text-gray-700 transition-colors duration-200 transform focus:outline-none hover:text-gray-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>

              <h3 className="text-lg text-left">
                How can I integrate this with my existing node application
              </h3>
            </button>
          </div>
        </div>
      </section>

      <footer className="mt-12 bg-primary">
        <div className="container flex flex-col items-center px-6 py-16 mx-auto md:justify-between md:flex-row">
          <div className="flex flex-col items-center md:items-start">
            <svg className="h-8" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.54607 4.14488C7.5418 4.14488 8.53966 5.31099 8.53966 7.64321V11.9247C8.53966 12.2496 8.44104 12.5049 8.24378 12.6905C8.05813 12.8762 7.79706 12.969 7.46058 12.969C7.12409 12.969 6.85722 12.8762 6.65997 12.6905C6.46271 12.5049 6.36409 12.2496 6.36409 11.9247V7.64321C6.36409 7.02824 6.23645 6.58153 5.98119 6.30305C5.73752 6.01298 5.34882 5.86794 4.81508 5.86794C4.18851 5.86794 3.68378 6.06519 3.30088 6.45969C2.92958 6.8542 2.74393 7.38214 2.74393 8.04351V11.9247C2.74393 12.2496 2.64531 12.5049 2.44806 12.6905C2.2508 12.8762 1.98393 12.969 1.64744 12.969C1.31096 12.969 1.04408 12.8762 0.846833 12.6905C0.661184 12.5049 0.568359 12.2496 0.568359 11.9247V1.51679C0.568359 1.21511 0.666985 0.971447 0.864237 0.785798C1.07309 0.600149 1.33996 0.507324 1.66485 0.507324C1.98973 0.507324 2.2508 0.594347 2.44806 0.768393C2.64531 0.942439 2.74393 1.1803 2.74393 1.48198V5.53725C3.03401 5.08473 3.41691 4.74244 3.89264 4.51038C4.37996 4.26672 4.93111 4.14488 5.54607 4.14488Z" fill="white" />
              <path fillRule="evenodd" clipRule="evenodd" d="M14.6965 0.557296C15.1495 0.718018 15.3864 1.21549 15.2257 1.66844L11.3966 12.4593C11.2359 12.9122 10.7385 13.1491 10.2855 12.9884C9.83256 12.8277 9.59567 12.3302 9.75639 11.8773L13.5854 1.08641C13.7461 0.633467 14.2436 0.396574 14.6965 0.557296Z" fill="white" />
            </svg>

            <p className="mt-6 text-white">Product by hlth.dev</p>
          </div>

        <div className="flex flex-col w-full mt-8 space-y-3 lg:mt-0 sm:w-auto sm:space-x-4 sm:space-y-0 sm:flex-row">
          <input placeholder="Enter Your Email" type="text" className="px-6 py-3 text-white bg-transparent border-2 border-gray-300 rounded-md sm:w-80 placeholder-slate-300 focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40" />

          <button className="px-8 py-2 text-center capitalize transition-colors duration-200 transform bg-white rounded-md text-primary hover:bg-opacity-80">
            Join Waitlist
          </button>
        </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
